import { render, staticRenderFns } from "./BindTel.vue?vue&type=template&id=b64e298c&scoped=true"
import script from "./BindTel.vue?vue&type=script&lang=js"
export * from "./BindTel.vue?vue&type=script&lang=js"
import style0 from "./BindTel.vue?vue&type=style&index=0&id=b64e298c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64e298c",
  null
  
)

export default component.exports